import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React from 'react';
import { ExperiencePerformanceTypes, ExperienceTypes, ConcurrentExperience } from '@atlaskit/ufo';
export var mentionRenderedUfoExperience = new ConcurrentExperience('mention-rendered', {
  platform: {
    component: 'mention'
  },
  type: ExperienceTypes.Load,
  performanceType: ExperiencePerformanceTypes.PageSegmentLoad
});
export var UfoErrorBoundary = /*#__PURE__*/function (_React$Component) {
  _inherits(UfoErrorBoundary, _React$Component);
  var _super = _createSuper(UfoErrorBoundary);
  function UfoErrorBoundary() {
    _classCallCheck(this, UfoErrorBoundary);
    return _super.apply(this, arguments);
  }
  _createClass(UfoErrorBoundary, [{
    key: "componentDidCatch",
    value: function componentDidCatch() {
      mentionRenderedUfoExperience.getInstance(this.props.id).failure();
    }
  }, {
    key: "render",
    value: function render() {
      return this.props.children;
    }
  }]);
  return UfoErrorBoundary;
}(React.Component);